import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Typography,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  WhatshotIcon,
  FormHelperText,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  commonService,
  Radio,
  OutlinedInput,
  FormControlLabel,
  RadioGroup,
} from "../../../common";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3rem",
    padding: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  formLabel: {
    color: "#2B335E",
    fontSize: "1.25rem",
    letterSpacing: "0.014375rem",
    margin: "0 0 0 0.75rem",
  },
  error: {
    color: "#FF0F0F",
  },
  radioBtnStyle: {
    border: "1px solid #BEBDBD",
    width: "100%",
    borderRadius: "5px",
    margin: "0 0 0 -1px",
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  btnContainer: {
    paddingTop: "5rem",
  },
  divider: {
    marginTop: "3rem",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GreenRadio = withStyles({
  root: {
    color: "#BEBDBD",
    "&$checked": {
      color: "#FC2861",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
let totalInputLengthArr = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];
export default function CreatePerTransactionLimit() {
  const classes = useStyles();
  const [userTypeList, setUserTypeList] = useState([]);
  const [userType, setUserType] = useState("");
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [transactionType, setTransactionType] = useState("");
  const [currency, setCurrency] = useState("20");
  const [level, setLevel] = useState("");
  const [levelTypeList, setLevelTypeList] = useState([]);
  const [maxNoOfTransaction, setMaxNoOfTransaction] = useState("");
  const [limitType, setLimitType] = useState("1");
  const [totalTransactionAmount, setTotalTransactionAmount] = useState("");
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [limitTypeList, setLimitTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  // const [selectedRadioVal, setSelectedRadioVal] = React.useState(false);
  const [remainingInputfield, setRemainingInputfield] = React.useState(8);
  const [totalInputfield, setTotalInputfield] = React.useState(8);
  //const [radioSelectionStyle, setRadioSelectionStyle] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    const limitInfo = {
      user_type_id: userType,
      level_id: level,
      transaction_type_id: transactionType,
      limit_type_id: limitType,
      user_account_type_id: 1,
      currency_id: currency,
      min_tx_amount: totalTransactionAmount,
      max_tx_amount: maxNoOfTransaction,
    };
    setLoading(true);



    if (handleError()) {
      const res = await commonService.createLimitPerTransaction(limitInfo);
      res?.code === 200 && setOpen(true);
      setLoading(false);
      setSuccessMsgBody("Limit Successfully Added.");
      setTimeout(() => {
        clearFormInput();
      }, 2000);
      res?.code !== 200 && setError(true);
      setLoading(false);
      setErrorMsgBody(res.messages[0]);
    } else {
      timer.current = window.setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleError = () => {
    let formIsValid = true;
    let errors = {};
    if (userType === "") {
      formIsValid = false;
      errors["userType"] = "User Type can't left empty.";
    }
    if (transactionType === "") {
      formIsValid = false;
      errors["transactionType"] = "Transaction Type can't left empty.";
    }
    if (level === "") {
      formIsValid = false;
      errors["level"] = "Level can't left empty.";
    }
    if (currency === "") {
      formIsValid = false;
      errors["currency"] = "Currency can't left empty.";
    }
    if (maxNoOfTransaction === "") {
      formIsValid = false;
      errors["maxNoOfTransaction"] = "Maximum Transaction Amount can't left empty.";;
    }
    if (totalTransactionAmount === "") {
      formIsValid = false;
      errors["totalTransactionAmount"] =
        "Minimum Transaction Amount can't left empty.";
    }

    setErrors(errors);
    return formIsValid;
  };

  const onChangeLimitType = (e) => {
    // console.log('e', e);
    // console.log('e', e.target.id);
    // let getids = document.getElementById(e.target.id);
    // let getRadiogroup = document.getElementsByClassName('limitTypeRadioGroup');

    // console.log('getids', getids);
    // console.log('getRadiogroup', getRadiogroup);

    // console.log('e', e.target.offsetParent.parentElement);
    // e.target.offsetParent.parentElement.className = 'radioChecked';

    if (e.target.value !== "") {
      if (totalInputLengthArr[6] == false) {
        totalInputLengthArr[6] = true;
        setRemainingInputfield(remainingInputfield - 1);
      }
    }

    setLimitType(e.target.value);
    setErrors({});
  };

  const clearFormInput = () => {
    setRemainingInputfield(8);

    setCurrency("");
    setTransactionType("");
    setUserType("");
    setLevel("");
    setLimitType("");
    setMaxNoOfTransaction("");
    setTotalTransactionAmount("");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const timer = React.useRef();

  const getUserTyps = async () => {
    // const userTypeList = await commonService.getUserType();
    // setUserTypeList(userTypeList.data?.user_types);
    setUserTypeList([{id: 4, name: 'Personal'}]);
  };

  const getCurrenciess = async () => {
    const currency = await commonService.getCurrencies();
    setCurrencyList(currency.data?.currencies);
  };

  const getLimitTypes = async () => {
    const limitType = await commonService.getLimitType();
    setLimitTypeList(limitType.data?.limit_types);
  };

  useEffect(() => {
    getUserTyps();
    getCurrenciess();
    getLimitTypes();

    // var totalinputFieldLength = document.getElementsByClassName(
    //   'MuiGrid-root MuiGrid-item MuiGrid-grid-xs-6'
    // ).length;
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const getTransactionTypeList = async (sender) => {
    const transactionType = await commonService.getTransactionTypeLimit(sender);
    setTransactionTypeList(transactionType.data?.transaction_types);
  };

  const getLevelsList = async (user_type_id) => {
    const levelType = await commonService.getLevel(user_type_id);
    setLevelTypeList(levelType.data?.levels);
  };

  return (
    <Grid xl={12} container className={classes.root}>
      {/* {console.log('totalInputLengthArr', totalInputLengthArr)} */}
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Grid item xl={12}>
        <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
          <NavLink color="inherit" to="/dashboard" className={classes.link}>
            <HomeIcon className={classes.icon} />
            Home
          </NavLink>
          <NavLink
            color="inherit"
            to="/per-transaction-limit/view-all"
            className={classes.link}
          >
            <WhatshotIcon className={classes.icon} />
            Per Transaction Limit
          </NavLink>
          <Typography color="textPrimary" className={classes.link}>
            Create
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              textAlign: "left",
              margin: "15px 0",
              color: "#2B335E",
              fontSize: "25px",
            }}
          >
            Create Per Transaction Limit
          </Typography>

          <NavLink
            to="/per-transaction-limit/view-all"
            variant="contained"
            style={{ height: "30px", textDecoration: "none" }}
          >
            <Typography
              style={{
                color: "#2B335E",
                fontSize: "18px",
              }}
            >
              View Per Transaction Limit List
            </Typography>
          </NavLink>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper style={{ padding: "20px", textAlign: "left" }}>
          <Grid container spacing={2}>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    User Type
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      placeholder="Select User Type"
                      value={userType}
                      name="userType"
                      onChange={(e) => {
                        setUserType(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          getTransactionTypeList(e.target.value);
                          getLevelsList(e.target.value);

                          if (totalInputLengthArr[0] == false) {
                            totalInputLengthArr[0] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[0] = false;
                        }
                      }}
                      label="User Type"
                      notched={false}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {userTypeList.map((user) => (
                        <MenuItem value={user.id}>{user.name}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText className={classes.error}>
                      {errors["userType"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Transaction Type
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={transactionType}
                      name="transactionType"
                      onChange={(e) => {
                        setTransactionType(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[1] == false) {
                            totalInputLengthArr[1] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[1] = false;
                        }
                      }}
                      label="Transaction Type"
                      notched={false}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {transactionTypeList.map((user) => (
                        <MenuItem value={user.id}>{user.name}</MenuItem>
                      ))}
                    </Select>

                    <FormHelperText className={classes.error}>
                      {errors["transactionType"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Level
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={level}
                      name="level"
                      onChange={(e) => {
                        setLevel(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[2] == false) {
                            totalInputLengthArr[2] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[2] = false;
                        }
                      }}
                      label="Level"
                      notched={false}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {levelTypeList.map((user) => (
                        <MenuItem value={user.id}>{user.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormHelperText className={classes.error}>
                    {errors["level"]}
                  </FormHelperText>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Currency
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <Select
                      variant="outlined"
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={currency}
                      onChange={(e) => {
                        setCurrency(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[3] == false) {
                            totalInputLengthArr[3] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[3] = false;
                        }
                      }}
                      label="Currency"
                      name="Currency"
                      notched={false}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {currencyList.map((user) => (
                        <MenuItem value={user.id}>{user.name}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText className={classes.error}>
                      {errors["currency"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>


            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Minimum Transaction Amount
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <OutlinedInput
                      labelId="demo-simple-select-filled-label"
                      name="totalTransactionAmount"
                      id="demo-simple-select-filled"
                      value={totalTransactionAmount}
                      onChange={(e) => {
                        setTotalTransactionAmount(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[7] == false) {
                            totalInputLengthArr[7] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[7] = false;
                        }
                      }}
                    ></OutlinedInput>
                    <FormHelperText className={classes.error}>
                      {errors["totalTransactionAmount"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
                  <InputLabel
                    id="demo-simple-select-filled-label"
                    className={classes.formLabel}
                  >
                    Maximum Transaction Amount
                  </InputLabel>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    size="small"
                    id="sender"
                  >
                    <OutlinedInput
                      labelId="demo-simple-select-filled-label"
                      id="demo-simple-select-filled"
                      value={maxNoOfTransaction}
                      name="maxNoOfTransaction"
                      onChange={(e) => {
                        setMaxNoOfTransaction(e.target.value);
                        setErrors({});
                        if (e.target.value !== "") {
                          if (totalInputLengthArr[5] == false) {
                            totalInputLengthArr[5] = true;
                            setRemainingInputfield(remainingInputfield - 1);
                          }
                        } else {
                          setRemainingInputfield(remainingInputfield + 1);
                          totalInputLengthArr[5] = false;
                        }
                      }}
                    ></OutlinedInput>
                    <FormHelperText className={classes.error}>
                      {errors["maxNoOfTransaction"]}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            
            <Grid
              item
              xl={12}
              md={12}
              sm={12}
              xs={12}
              lg={12}
              justify="space-between"
              alignItems="center"
              className={classes.divider}
            >
              {" "}
              <Divider style={{ margin: "20px 0", color: "#00000029" }} />
            </Grid>

            <Grid
              item
              container
              xl={12}
              justify="space-between"
              alignItems="center"
              className={classes.btnContainer}
            >
              <Grid item xl={6} md={6} sm={6} xs={6} lg={6}>
                {/* <Box ml={1}>
                  {remainingInputfield}/{totalInputfield} input remaining
                </Box> */}
              </Grid>
              <Grid
                item
                container
                xl={6}
                md={6}
                sm={6}
                xs={6}
                lg={6}
                justify="flex-end"
                alignItems="center"
              >
                <Box mr={5}>
                  <Button
                    variant="contained"
                    className={classes.cancelBtn}
                    onClick={clearFormInput}
                  >
                    CANCEL
                  </Button>
                </Box>
                <Box mr={1}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    disabled={loading}
                    className="btn btn-primary btn-block"
                  >
                    {loading && <CircularProgress size={17} />}
                    Create & add another
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
